<template>
  <div class="t-day" :class="{'t-day_select': active, 't-day_small': mobileCalendar, '_today': today}" @click.prevent="OpenDay()">
    <p class="t-day__date">{{ day }}</p>
    <template v-if="active && !mobileCalendar" >
      <p class="t-day__name">{{ count + ' ' + declOfNum(count, calendarText.eventArr2) }}</p>
      <p class="t-day__time">{{ applications + ' ' + declOfNum(applications, calendarText.applicationArr) }}</p>
    </template>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    export  default {
        props: ['day'],
        data(){
            return{
                count: 0,
                applications: 0,

                today: false
            }
        },
        computed: {
            ...mapGetters(['mobileCalendar']),
            ...mapGetters('calendar', ['date_active', 'calendarText']),
            ...mapGetters('coursesList', ['streamsEntries']),
            active(){
                this.count = 0;
                this.applications = 0;

                let date = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.day;

                let today = new Date(),
                    today_text = today.getFullYear() + '.' + (today.getMonth() + 1) + '.' + today.getDate();

                this.today = today_text === date;

                for(let s = 0; s < this.streamsEntries.length; s++){
                    let streams = this.streamsEntries[s];

                    for(let l = 0; l < streams.lessons.length; l++){
                        let lesson = streams.lessons[l];

                        let day = new Date(lesson.date_time);
                        let date_2 = day.getFullYear() + '.' + (day.getMonth() + 1) + '.' + day.getDate();

                        if(date_2 === date){
                            if(streams.applications.confirmed)
                                this.count++;
                            else
                                this.applications++;
                        }
                    }
                }
                return this.count > 0 || this.applications > 0
            }
        },
        methods: {
            ...mapActions('calendar', ['SetType', 'GoTo']),
            declOfNum(n, titles) {
                return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]
            },
            OpenDay(){
                this.GoTo(this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.day);
                this.SetType({value: 2,label: 'Неделя'});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/vue_components/Calendar/MyEntries/Day.vue